export enum FaixaSimplesNacionalEnum {

  A,
  B,
  C
}
